/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type newMagazine = {|
  name: string,
  backgroundColor?: ?string,
  backgroundImage?: ?string,
  companyLogo?: ?string,
  mainTemplateId: string,
  subTemplateId: number,
  portalId: string,
  rows?: ?$ReadOnlyArray<?InputRows>,
  thumbnail?: ?string,
  tags?: ?$ReadOnlyArray<?string>,
  accountId: string,
|};
export type InputRows = {|
  content?: ?$ReadOnlyArray<?InputCard>,
  isShown?: ?boolean,
|};
export type InputCard = {|
  heading?: ?string,
  subHeading?: ?string,
  description?: ?string,
  headerImage?: ?string,
  fileUrl?: ?string,
  videoThumbnail?: ?string,
  cardThumbnail?: ?string,
  headerOverlayContent?: ?string,
  linkTo?: ?string,
  buttonText?: ?string,
  graphData?: ?InputGraph,
|};
export type InputGraph = {|
  attr1?: ?string,
  attr2?: ?string,
  attr3?: ?string,
  data?: ?$ReadOnlyArray<?InputData>,
|};
export type InputData = {|
  name?: ?string,
  val1?: ?number,
  val2?: ?number,
  val3?: ?number,
|};
export type CreateMagazineMutationVariables = {|
  magazine?: ?newMagazine
|};
export type CreateMagazineMutationResponse = {|
  +createMagazine: ?{|
    +_id?: string,
    +id?: string,
    +name?: string,
    +backgroundColor?: ?string,
    +backgroundImage?: ?string,
    +mainTemplateId?: string,
    +subTemplateId?: number,
    +portalId?: string,
    +rows?: ?$ReadOnlyArray<?{|
      +content: ?$ReadOnlyArray<?{|
        +description: ?string,
        +headerImage: ?string,
        +fileUrl: ?string,
        +videoThumbnail: ?string,
        +cardThumbnail: ?string,
        +headerOverlayContent: ?string,
        +heading: ?string,
        +subHeading: ?string,
        +graphData: ?{|
          +attr1: ?string,
          +attr2: ?string,
          +attr3: ?string,
          +data: ?$ReadOnlyArray<?{|
            +name: ?string,
            +val1: ?number,
            +val2: ?number,
            +val3: ?number,
          |}>,
        |},
      |}>,
      +isShown: ?boolean,
    |}>,
    +tags?: ?$ReadOnlyArray<?string>,
    +creator?: string,
    +accountId?: ?string,
    +createdAt?: any,
    +updatedAt?: ?any,
    +hash?: ?string,
    +message?: string,
    +shared?: ?string,
    +signedUrl?: ?string,
    +status?: number,
    +success?: boolean,
    +token?: ?string,
    +userId?: ?string,
  |}
|};
export type CreateMagazineMutation = {|
  variables: CreateMagazineMutationVariables,
  response: CreateMagazineMutationResponse,
|};
*/


/*
mutation CreateMagazineMutation(
  $magazine: newMagazine
) {
  createMagazine(magazine: $magazine) {
    __typename
    ... on Magazine {
      _id
      id
      name
      backgroundColor
      backgroundImage
      mainTemplateId
      subTemplateId
      portalId
      rows {
        content {
          description
          headerImage
          fileUrl
          videoThumbnail
          cardThumbnail
          headerOverlayContent
          heading
          subHeading
          graphData {
            attr1
            attr2
            attr3
            data {
              name
              val1
              val2
              val3
            }
          }
        }
        isShown
      }
      tags
      creator
      accountId
      createdAt
      updatedAt
    }
    ... on Response {
      hash
      message
      shared
      signedUrl
      status
      success
      token
      userId
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "magazine"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "magazine",
    "variableName": "magazine"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Row",
      "kind": "LinkedField",
      "name": "rows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Card",
          "kind": "LinkedField",
          "name": "content",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "headerImage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoThumbnail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cardThumbnail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "headerOverlayContent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heading",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subHeading",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Graph",
              "kind": "LinkedField",
              "name": "graphData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "attr1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "attr2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "attr3",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GraphData",
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "val1",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "val2",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "val3",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShown",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Magazine",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shared",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "type": "Response",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMagazineMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createMagazine",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateMagazineMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createMagazine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6351d3c269cb01fbc070457f42eed02a",
    "id": null,
    "metadata": {},
    "name": "CreateMagazineMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMagazineMutation(\n  $magazine: newMagazine\n) {\n  createMagazine(magazine: $magazine) {\n    __typename\n    ... on Magazine {\n      _id\n      id\n      name\n      backgroundColor\n      backgroundImage\n      mainTemplateId\n      subTemplateId\n      portalId\n      rows {\n        content {\n          description\n          headerImage\n          fileUrl\n          videoThumbnail\n          cardThumbnail\n          headerOverlayContent\n          heading\n          subHeading\n          graphData {\n            attr1\n            attr2\n            attr3\n            data {\n              name\n              val1\n              val2\n              val3\n            }\n          }\n        }\n        isShown\n      }\n      tags\n      creator\n      accountId\n      createdAt\n      updatedAt\n    }\n    ... on Response {\n      hash\n      message\n      shared\n      signedUrl\n      status\n      success\n      token\n      userId\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '12e41d5e62122e20afc51e983e4220ee';

module.exports = node;
